import { render, staticRenderFns } from "./comTerm13.vue?vue&type=template&id=6b270664&scoped=true&"
import script from "./comTerm13.vue?vue&type=script&lang=js&"
export * from "./comTerm13.vue?vue&type=script&lang=js&"
import style0 from "./comTerm13.vue?vue&type=style&index=0&id=6b270664&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b270664",
  null
  
)

export default component.exports